export default "__VITE_ASSET__BmvSUfhb__"